// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"6c8751b0","433":"ef20c97f","571":"22bacbd6","614":"3ff410b6","623":"ea8b62ce","702":"9dd930a0","854":"829e769a"}[chunkId] + ".chunk.css";
};